import { TableCell, TableRow } from '@/components/ui/table'
import { ReactNode } from 'react'

interface DataTableRowProps {
  onClick?: () => void
  children: ReactNode
}

export const DataTableRow = ({ onClick, children }: DataTableRowProps) => {
  return (
    <TableRow onClick={onClick} className={onClick ? 'cursor-pointer hover:bg-muted/50 transition-colors' : ''}>
      {children}
    </TableRow>
  )
}
